module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9780061745287_frontmatterpage#ack01"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "int_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/9780061745287_frontmatterpage_02#int01"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/9780061745287_chapter_01#ch01"
    }
  }, [_vm._v("1   The Basics")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2   Growing Up")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3   Coming Out/Going Public")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4   Family and Children")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5   For Parents of Gay Children")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6   Dating, Relationships, and Marriage")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7   Sex")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8   Work and the Military")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9   Where Gay and Lesbian People Live")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10  Socializing and Friends")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11  Religion")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12  Discrimination and Antigay Violence")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13  Movies, Television, and Print Media")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14  Sports")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15  Education")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16  Politics and Activism")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17  Aging")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18  Miscellaneous Questions")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "bib_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_backmatterpage#bib01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "bm_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_backmatterpage_02#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ind_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_backmatterpage_03#ind01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searchable Terms")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ata_1"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_aboutauthor#ata1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "adc_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_adcard#adc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by Eric Marcus")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_copyright#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/9780061745287_aboutpublisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page06"
    }
  })]), _c('a', {
    attrs: {
      "id": "page06"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c5036fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061745287_contents.vue
// module id = 66
// module chunks = 0